export const discountMinimumValue = 2000;

export const amountOptions = [
    {
        id: 1,
        amount: 1000,
        preSelected: false,
        text: "₹1000",
    },
    {
        id: 2,
        amount: 2000,
        mostPopular: true,
        preSelected: true,
        text: "₹2000",
    },
    {
        id: 3,
        amount: 5000,
        preSelected: false,
        text: "₹5000",
    },
];

export const GENERIC_GIFTING_BANNER_CONFIG = "portal/m/generic_gifting_banner.png";
export const GENERIC_GIFTING_ENVELOPE_CONFIG = "portal/m/generic_gifting_envelope.png";

export const CHRISTMAS_GIFTING_BANNER_CONFIG = "portal/m/sm_gifting/christmas_gifting_banner.png";
export const CHRISTMAS_GIFTING_ENVELOPE_CONFIG = "portal/m/sm_gifting/christmas_gifting_banner_envelope.png";

export const NYE_GIFTING_BANNER_CONFIG = "portal/m/sm_gifting/newyear_2025.png";
export const NYE_GIFTING_ENVELOPE_CONFIG = "portal/m/sm_gifting/newyear_2025_envelope.png";

export const RAKSHA_BANDHAN_BANNER_CONFIG = "portal/m/RBCard.png";
export const RAKSHA_BANDHAN_GIFTING_ENVELOPE_CONFIG = "portal/m/Rakshabandhan_gift.png";

export const GENERIC_MESSAGE_PLACEHOLDER = "Happy ordering on Swiggy!";
export const CHRISTMAS_MESSAGE_PLACEHOLDER = "Merry Christmas to you & your family!";
export const NYE_MESSAGE_PLACEHOLDER = "Happy new year to you & your family!";
export const RAKSHA_BANDHAN_MESSAGE_PLACEHOLDER = "Happy Raksha Bandhan!";

// Diwali and Bhai dooj config
export const DIWALI_MESSAGE_PLACEHOLDER = "Happy Diwali!";
export const DIWALI_BANNER_CONFIG = "portal/m/sm_gifting/Diwali_card_24.png";
export const DIWALI_GIFTING_ENVELOPE_CONFIG = "portal/m/sm_gifting/Diwali_envelope_24.png";

export const BHAI_DOOJ_MESSAGE_PLACEHOLDER = "Happy Bhai Dooj!";
export const BHAI_DOOJ_BANNER_CONFIG = "portal/m/sm_gifting/Bhaidooj_card_24.png";
export const BHAI_DOOJ_GIFTING_ENVELOPE_CONFIG = "portal/m/sm_gifting/Bhaidooj_envelope_24.png";

export const CardBannerConfig = [
    {
        mainImageUrl: GENERIC_GIFTING_BANNER_CONFIG,
        mainImageWithEnvelopeUrl: GENERIC_GIFTING_ENVELOPE_CONFIG,
        discountPercentage: 0,
        timeRangeStart: 1702665000000, // "December 16, 2023 00:00:00 GMT+05:30"
        timeRangeEnd: 1702924200000, // "December 19, 2023 00:00:00 GMT+05:30",
        defaultMessagePlaceholder: GENERIC_MESSAGE_PLACEHOLDER,
    },
    {
        mainImageUrl: RAKSHA_BANDHAN_BANNER_CONFIG,
        mainImageWithEnvelopeUrl: RAKSHA_BANDHAN_GIFTING_ENVELOPE_CONFIG,
        discountPercentage: 0,
        timeRangeStart: 1723746600000, // "Aug 16, 2024 00:00:00 GMT+0530"
        timeRangeEnd: 1724092199000, // "Aug 19, 2024 23:59:59 GMT+0530"
        defaultMessagePlaceholder: RAKSHA_BANDHAN_MESSAGE_PLACEHOLDER,
    },
    {
        mainImageUrl: DIWALI_BANNER_CONFIG,
        mainImageWithEnvelopeUrl: DIWALI_GIFTING_ENVELOPE_CONFIG,
        discountPercentage: 0,
        timeRangeStart: 1729708200000, // "24 Oct, 2024 00:00:00 GMT+0530"
        timeRangeEnd: 1730572199000, // "2 Nov, 2024 23:59:59 GMT+0530"
        defaultMessagePlaceholder: DIWALI_MESSAGE_PLACEHOLDER,
    },
    {
        mainImageUrl: BHAI_DOOJ_BANNER_CONFIG,
        mainImageWithEnvelopeUrl: BHAI_DOOJ_GIFTING_ENVELOPE_CONFIG,
        discountPercentage: 0,
        timeRangeStart: 1730572200000, // "Nov 3, 2024 00:00:00 GMT+0530"
        timeRangeEnd: 1730658599000, // "Nov 3, 2024 23:59:59 GMT+0530"
        defaultMessagePlaceholder: BHAI_DOOJ_MESSAGE_PLACEHOLDER,
    },
    {
        mainImageUrl: CHRISTMAS_GIFTING_BANNER_CONFIG,
        mainImageWithEnvelopeUrl: CHRISTMAS_GIFTING_ENVELOPE_CONFIG,
        discountPercentage: 0,
        timeRangeStart: 1734633000000, // "December 20, 2024 00:00:00 GMT+05:30",
        timeRangeEnd: 1735151399000, // "December 25, 2024 23:59:59 GMT+05:30",
        defaultMessagePlaceholder: CHRISTMAS_MESSAGE_PLACEHOLDER,
    },
    {
        mainImageUrl: NYE_GIFTING_BANNER_CONFIG,
        mainImageWithEnvelopeUrl: NYE_GIFTING_ENVELOPE_CONFIG,
        discountPercentage: 0,
        timeRangeStart: 1735151400000, // "December 26, 2023 00:00:00 GMT+05:30",
        timeRangeEnd: 1735756199000, // "January 1, 2025 23:59:59 GMT+05:30"
        defaultMessagePlaceholder: NYE_MESSAGE_PLACEHOLDER,
    },
];

export const DefaultCardConfig = {
    mainImageUrl: GENERIC_GIFTING_BANNER_CONFIG,
    mainImageWithEnvelopeUrl: GENERIC_GIFTING_ENVELOPE_CONFIG,
    discountPercentage: 0,
    defaultMessagePlaceholder: GENERIC_MESSAGE_PLACEHOLDER,
};

export const ALREADY_CLAIMED_STATUS_CODE = 7;

export const ALREADY_CLAIMED_ERROR_IMAGE = "portal/m/sm_gifting/ClaimedGift.png";

export const EXPIRED_GIFTCARD_STATUS_CODE = 8;

export const EXPIRED_GIFTCARD_ERROR_IMAGE = "portal/m/sm_gifting/ExpiredGift.png";

export const INVALID_GIFTCARD_ERROR_IMAGE = "portal/m/sm_gifting/InvalidGift.png";

export const APP_STORE_LINK = "https://www.swiggy.com/app";
